import Block from '@components/Layout/Block';
import { VerticalLineSeparator } from '@components/MiscComponents/VerticalLineSeparator';
import RichText from '@components/RichText';
import { Document } from '@contentful/rich-text-types';
import { FC } from 'react';
import { Eyebrow, Header, Text } from './styles';

export interface IntroTextBlockProps {
  eyebrow?: string;
  header?: string;
  richText?: Document;
  bodyText?: string;
  swatch?: 'cream' | 'bg';
}

const IntroTextBlock: FC<IntroTextBlockProps> = ({
  eyebrow,
  header,
  richText,
  bodyText,
  swatch,
}) => {
  return (
    <Block narrow background={swatch == 'cream' ? 'secondaryBg' : 'bg'}>
      {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
      {header && <Header data-testid={`intro-text-block-${header}`}>{header}</Header>}
      {header && (bodyText || richText) && <VerticalLineSeparator />}

      {bodyText && <Text>{bodyText}</Text>}
      {richText && (
        <Text>{typeof richText === 'string' ? richText : <RichText richText={richText} />}</Text>
      )}
    </Block>
  );
};

export default IntroTextBlock;
